function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#zip_svg__clip0)",
  fill: "#0785FE"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.188 5.156V3.281a.469.469 0 00-.136-.333L9.239.136A.469.469 0 008.906 0h-7.5C.63 0 0 .63 0 1.406v12.188C0 14.37.63 15 1.406 15h3.282v-.938H1.405a.469.469 0 01-.468-.468V1.405c0-.259.21-.469.468-.469h7.032v1.875c0 .518.42.938.937.938h1.875v1.406h.938zM14.063 7.5h-1.876a.469.469 0 00-.468.469v4.218h.937v-1.406h1.406c.518 0 .938-.42.938-.937V8.438a.937.937 0 00-.938-.938zm0 2.344h-1.407V8.438h1.406v1.406z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.25 7.5h-.938v4.688h.938V7.5zM9.624 7.571a.469.469 0 00-.249-.071H6.562v.938h1.97L6.655 11.47a.469.469 0 00.375.717h2.813v-.937H7.875l1.898-3.033a.469.469 0 00-.149-.646z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "zip_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15v15H0z"
})));

function SvgZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgZip;